import ConfigService from '../index'
// import CustomRequestException from '../../exceptions/CustomRequestException'
class MoodleUNDBService extends ConfigService {
    constructor(){
        super('moodle/api/v1/')
    }
    async get_query_perlets(params){
        return await this.get('undb_classroom/query_perlets/', params)
    }
    async get_query_cursos(params){
        return await this.get('undb_classroom/query_cursos/', params)
    }
    async get_query_turmas(params){
        return await this.get('undb_classroom/query_turmas/', params)
    }
    async get_query_turmas_g(params){
        return await this.get('undb_classroom/query_turmas_g/', params)
    }
    async get_query_disciplinas(params){
        return await this.get('undb_classroom/query_disciplinas/', params)
    }
    async get_query_disciplinas_g(params){
        return await this.get('undb_classroom/query_disciplinas_g/', params)
    }
    async get_query_alunos(params){
        return await this.get('undb_classroom/query_alunos/', params)
    }
    async get_query_alunos_g(params){
        return await this.get('undb_classroom/query_alunos_g/', params)
    }
    async get_query_professores(params){
        return await this.get('undb_classroom/query_professores/', params)
    }
    async get_query_professores_g(params){
        return await this.get('undb_classroom/query_professores_g/', params)
    }
    async get_query_coordenadores(params){
        return await this.get('undb_classroom/query_coordenadores/', params)
    }
    async get_query_coordenadores_g(params){
        return await this.get('undb_classroom/query_coordenadores_g/', params)
    }
    async get_query_gerenciadas_g(params){
        return await this.get('undb_classroom/query_gerenciadas_g/', params)
    }
    async reset_moodle_password(data){
        return await this.post('undb_classroom/reset_password/', data)
    }
    async reset_moodle_password_pos(data){
        return await this.post('undb_pos/reset_password/', data)
    }
    async find_user(params){
        return await this.get('undb_classroom/find_user/', params)
    }
    async find_user_pos(params){
        return await this.get('undb_pos/find_user/', params)
    }
    async get_logs(params){
        return await this.get('logs/', params)
    }
    async integra(params){
        return await this.get('undb_classroom/integra/', params)
    }
    async get_logs_reset_password(params){
        return await this.get('logs_reset_password/', params)
    }
}
export default MoodleUNDBService
